export default {
  props: {
    compId: String,
    labelKey: String,
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    imgs() {
      if (this.compProps.isLinkFilter) {
        const { filterItems } = this.compProps
        let items = filterItems[0].items || []
        filterItems.forEach((item, index) => {
          if (item.labelKey === this.labelKey) {
            items = item.items
          }
        })
        return items
      }
      if (this.compProps.items) {
        return this.compProps.items || []
      } else {
        return []
      }
    },
    delay() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.duration || 3000
      } else {
        return 3000
      }
    }
  },
  methods: {
    getLink(item) {
      if (this.platform === 1 && item && item.mpLink) {
        return item.mpLink
      } else if (this.platform === 2 && item && item.appLink) {
        return item.appLink
      } else if (item && item.activeLink) {
        return item.activeLink
      }
    },
    async clickHandle(info, index) {
      this.$emit('action', {
        ...info,
        imgIndex: index,
        timeStamp: new Date().getTime()
      })
    }
  }
}
